import { useState, useEffect } from 'react'

interface User {
  userId: string
  userDetails: string
  userRoles: string[]
  identityProvider: string
}

interface AuthInfo {
  user: User | null
  isAuthenticated: boolean
  isAdmin: boolean
  isLoading: boolean
}

export function useAuth(): AuthInfo {
  const [authInfo, setAuthInfo] = useState<AuthInfo>({
    user: null,
    isAuthenticated: false,
    isAdmin: false,
    isLoading: true
  })

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // In Azure Static Web Apps, user info is available at /.auth/me
        const response = await fetch('/.auth/me')
        
        if (response.ok) {
          const data = await response.json()
          
          if (data.clientPrincipal) {
            const user = data.clientPrincipal
            const isAdmin = user.userRoles?.includes('admin') || false
            
            setAuthInfo({
              user,
              isAuthenticated: true,
              isAdmin,
              isLoading: false
            })
          } else {
            // Not authenticated
            setAuthInfo({
              user: null,
              isAuthenticated: false,
              isAdmin: false,
              isLoading: false
            })
          }
        } else {
          // API not available or error
          setAuthInfo({
            user: null,
            isAuthenticated: false,
            isAdmin: false,
            isLoading: false
          })
        }
      } catch (error) {
        console.error('Auth check failed:', error)
        setAuthInfo({
          user: null,
          isAuthenticated: false,
          isAdmin: false,
          isLoading: false
        })
      }
    }

    checkAuth()
  }, [])

  return authInfo
}